import { ListItemTextProps, TypographyProps } from '@mui/material';

import { documentListItemTextClasses, DocumentListItemTextStyled } from './DocumentListItemText.styled';

const PRIMARY_LINE_HEIGHT = 23;

const clampProps = (numLines: number, className: string, lineHeight: number): TypographyProps => {
  return {
    className,
    style: {
      WebkitLineClamp: numLines,
      maxHeight: numLines * lineHeight,
    },
  };
};

export const DocumentListItemText = ({ primary }: ListItemTextProps) => {
  const primaryTypographyProps = {
    variant: 'body1',
    ...clampProps(2, documentListItemTextClasses.clamp, PRIMARY_LINE_HEIGHT),
  };

  return <DocumentListItemTextStyled primary={primary} slotProps={{ primary: primaryTypographyProps }} />;
};
